module.exports = __webpack_public_path__ + "img/yt_logo_rgb_dark.63bf7618.png";